export default "__VITE_ASSET__BRjFhS7___"